import { Component, OnInit } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { PdfTemplates } from "../../../../core/models/reportFooter/pdfTemplates";
import { PdfTemplateUpdateByIdRequestDto } from "../../../../core/models/reportFooter/pdfTemplateUpdateByIdRequestDto";
import { LoaderService } from "../../../../core/services/loader.service";
import { ManagementService } from "../../../../core/services/management.service";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ListboxClickEvent, ListboxModule } from "primeng/listbox";
import { EditorModule } from "primeng/editor";
import { SpinnerComponent } from "../../../../shared/components/spinner/spinner.component";

@UntilDestroy()
@Component({
  selector: "jni-report-footer-templates",
  templateUrl: "./report-footer-templates.component.html",
  styleUrls: ["./report-footer-templates.component.scss"],
  imports: [
    CommonModule,
    FormsModule,
    ListboxModule,
    EditorModule,
    SpinnerComponent,
  ],
})
export class ReportFooterTemplatesComponent implements OnInit {
  showSmallLoader = false;
  selectedPickListItem: { name: string; id: number } | null = null;
  templatesPickList!: {
    name: string;
    id: number;
  }[];

  editorText = "";
  pdfTemplatesList: PdfTemplates[] = [];

  constructor(
    private _loaderService: LoaderService,
    private _managementService: ManagementService,
    private _toastr: JniToastrService
  ) {}

  ngOnInit(): void {
    this.getAllTemplates();
  }

  getAllTemplates() {
    this.showSmallLoader = true;
    this._managementService
      .GetPdfTemplates()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res?.data && res?.status === "Success")
            this.pdfTemplatesList = res.data;
          this.mapTempaltesToPickList();
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
          this._toastr.error("Error", "No templates found");
        },
      });
  }

  mapTempaltesToPickList() {
    this.templatesPickList = this.pdfTemplatesList.map(item => {
      return {
        name: item.name,
        id: item.id,
      };
    });
  }

  getClickedTemplate(obj: ListboxClickEvent) {
    this.selectedPickListItem = obj?.option as { id: number; name: string };
    this.editorText =
      this.pdfTemplatesList.find(x => x.id === this.selectedPickListItem?.id)
        ?.htmlBody ?? "";
  }

  reportFooterUpdate() {
    const obj = {
      id: this.selectedPickListItem?.id,
      htmlBody: this.editorText,
    } as PdfTemplateUpdateByIdRequestDto;
    this._loaderService.setLoaderState(true);
    this._managementService
      .PdfTemplateUpdateById(obj)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res?.data) {
            this._loaderService.setLoaderState(false);
            this._toastr.success("Success", "Record updated successfully");
            this.getAllTemplates();
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", "No record is updated");
        },
      });
  }
}
